<template>
  <div>
    <div class="header">
      <div class="search-box">
          <input placeholder="请输入股票名称/代码" class="search"  v-model="keyword" v-on:input="searchStocks"/>
      </div>
      <!-- <div><img class="headimg" :src="$store.state.cust.avtarImg" v-on:click="showMyStocks" /></div> -->
    </div>
    <div class="match-list" v-if="searching">
      <ul v-if="matchList != null && matchList.length > 0">
        <li v-for="item in matchList" v-on:click="showStock(item.zqdm)">{{item.zqjc}}({{item.zqdm}})</li>
      </ul>
      <div v-else-if="matchList != null">无结果</div>
    </div>
    <div v-if="info">
      <div class="brief padding">
        <div class="info">
          <div class="name">{{info.zqjc}}</div>
          <!-- <div v-if="!info.hasAdded" class="add-stock-button" v-on:click="addStock">+&nbsp;自选</div> -->
          <!-- <div
            v-else
            class="add-stock-button"
            style="background-color:red;color:white;"
            v-on:click="removeStock"
          >√&nbsp;自选</div> -->
          <div class="help iconfont icon-help" @click="helpTotal = true"></div>
          <div class="zqdm">{{info.zqdm}}   <div style="float:right;color:black;font-family:'黑体';font-weight:bold;">赔率·胜率·效率</div></div>
          <div class="paihangbang">
            <div>
              <span>行业:</span>
              <span>{{info.indexName}}</span>
            </div>
            <div>
              <span>市值:</span>
              <span>{{info.asset | dataConvert}}亿</span>
            </div>
          </div>
        </div>
        <!-- <div style="height:120px;margin-top:0px;margin-bottom:20px;">
          <v-chart :options="mfdInFlowLineOptions" />
        </div> -->
        <!-- <div class="tips">
        <span>本工具不构成投资建议，投资有风险，请用户谨慎参考！</span>
        <span @click="helpMzsm=true">免责声明</span>
        </div>-->
      </div>
      <!-- 赔率 -->
      <!-- <div class="split"></div> -->
      <div class="padding">
        <div class="top_title">赔率</div>
        <div class="help iconfont icon-help" @click="helpPeilv = true"></div>
        <div style="color:grey;font-size:13px;">股票上涨的空间</div>
      </div>
      <div class="peilv padding">
        <div style="width:50%;display:inline-block;vertical-align:top;">
          <table>
            <tr><td :style="'line-height:1px;vertical-align: top;text-align: right;'">
              <div :style="'margin-top: ' + floatPos + 'px;'">
                  <div v-if="info.pb100 != null"><img src="/pc/img/arrow.jpg" style="width: 15px;margin-right: -2px;"></div>
                  <!-- <div v-if="info.pb100 != null" style="margin-right: -2px;font-weight: normal;font-size: 14px;color: red;">→</div> -->
                  <div v-else style="margin-right: -2px;font-weight: bold;font-size: 14px;color: red;">×</div>
              </div>
              </td>
              <td width="25">
                <div style="background:#999;width:6px; height:5px;margin-bottom:2px;"></div>
                <div style="background:#999;width:6px; height:5px;margin-bottom:2px;"></div>
                <div style="background:#999;width:6px; height:5px;margin-bottom:3px;"></div>
                <div style="background:#999;width:6px; height:5px;margin-bottom:3px;"></div>
                <div style="">
                  <div style="height:2px;width:6px;background-color:#000;position:relative;">
                    <div style="height: 2px;width: 5px;background-color: rgb(0, 0, 0);position: absolute;right: -5px;"></div>
                    <div style="position:absolute;top:1px;line-height:0px;right:-15px;color:#999;">H</div>
                  </div>
                  <!-- <div style="height: 2px;width: 16px;margin: 0px auto;position: relative;border-right: 10px solid rgb(0, 0, 0);">
                    <div style="position:absolute;top:-8px;right:-20px;color:rgb(192, 0 , 0)">L</div>
                  </div> -->
                  <div style="height:30px;width:6px;background-color:#000;position:relative;">
                  </div>
                  <!-- <div style="height: 16px;width: 16px;background-color: #999;border-radius: 8px;line-height: 16px;margin-left: -4px;font-size: 8px;text-align:center;">M</div> -->
                  <div style="height:1px;width:6px;background-color:#000;position:relative;">
                    <div style="height:1px;width: 5px;background-color: rgb(0, 0, 0);position: absolute;right: -5px;"></div>
                    <div style="position:absolute;top:-8px;right:-18px;color:#999">M</div>
                  </div>
                  <div style="height:30px;width:6px;background-color:#000;position:relative;">
                  </div>
                  <div style="height:2px;width:6px;background-color:#000;position:relative;">
                    <div style="height: 2px;width: 5px;background-color: rgb(0, 0, 0);position: absolute;right: -5px;"></div>
                    <div style="position:absolute;top:-8px;right:-15px;color:#999;">L</div>
                  </div>
                </div>
                <div style="background:#999;width:6px; height:5px;margin-top:3px;"></div>
                <div style="background:#999;width:6px; height:5px;margin-top:3px;"></div>
                <div style="background:#999;width:6px; height:5px;margin-top:2px;"></div>
                <div style="background:#999;width:6px; height:5px;margin-top:2px;"></div>
              </td>
              <td style="vertical-align:top;padding-top:10px;padding-left:10px;">
                <table>
                  <tr><td class="td-border-right td-border-bottom" height=20 style="color:#333;">一年</td>
                    <td class="td-border-right td-border-bottom" style="color:#333;">二年</td>
                    <td class="td-border-bottom" style="color:#333;">五年</td></tr>
                  <tr>
                    <td class="td-border-right" height="15" :style="'color:' + peilvColor(info.expyield1High)">{{$utils.format("%d%%", info.expyield1High)}}</td>
                    <td class="td-border-right" :style="'color:' + peilvColor(info.expyield2High)">{{$utils.format("%d%%", info.expyield2High)}}</td>
                    <td :style="'color:' + peilvColor(info.expyield5High)">{{$utils.format("%d%%", info.expyield5High)}}</td>
                  </tr>
                  <tr><td colspan="3" style="height:9px;"></td></tr>
                  <tr>
                    <td class="td-border-right" height="15" :style="'color:' + peilvColor(info.expyield1M)">{{$utils.format("%d%%", info.expyield1M)}}</td>
                    <td class="td-border-right" :style="'color:' + peilvColor(info.expyield2M)">{{$utils.format("%d%%", info.expyield2M)}}</td>
                    <td :style="'color:' + peilvColor(info.expyield5M)">{{$utils.format("%d%%", info.expyield5M)}}</td>
                  </tr>
                  <tr><td colspan="3" style="height:14px;"></td></tr>
                  <tr>
                    <td class="td-border-right" height="15" :style="'color:' + peilvColor(info.expyield1Low)">{{$utils.format("%d%%", info.expyield1Low)}}</td>
                    <td class="td-border-right" :style="'color:' + peilvColor(info.expyield2Low)">{{$utils.format("%d%%", info.expyield2Low)}}</td>
                    <td :style="'color:' + peilvColor(info.expyield5Low)">{{$utils.format("%d%%", info.expyield5Low)}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div style="width:5%;display:inline-block;"></div>
        <div class="rank">
          <v-chart :options="rankOptions" />
        </div>
      </div>
      <!-- 胜率 -->
      <div class="split"></div>
      <div class="padding">
        <div class="top_title">胜率</div>
        <div class="help iconfont icon-help" @click="helpShenglv = true"></div>
        <div style="color:grey;font-size:13px;">股票上涨的概率</div>
      </div>
      <div style="height:100px;">
          <div style="width:33%;height:100%;display:inline-block;"><v-chart :options="rps1PieOptions" /></div>
          <div style="width:33%;height:100%;display:inline-block;"><v-chart :options="rps2PieOptions" /></div>
          <div style="width:33%;height:100%;display:inline-block;"><v-chart :options="rps3PieOptions" /></div>
        </div>
      <div class="padding">
        <div style="height:200px;margin-top:20px;">
          <v-chart :options="shenglvLineOptions" />
        </div>
      </div>
      
      <div class="tabbar" style="margin-top: 0px;padding-top:10px;">
        <a
          v-for="tab in tabs2"
          :class="'tab ' + (tab2Sel==tab.code?'tab2Sel':'')"
          style="background-color:rgb(200, 66, 57)"
          v-on:click="tab2Sel=tab.code"
        >{{tab.name}}</a>
      </div>
      <div class="growing padding">
        <!-- <div class="title">成长空间</div> -->
        <!-- 净资产收益率ROE -->
        <div class="growing-item" v-if="tab2Sel == 'roe'">
          <div class="growing-item-title">
            <div>净资产收益率ROE</div>
            <div class="growing-item-button" v-on:click="showRoeDetail=!showRoeDetail">
              <span></span>预测
            </div>
          </div>
          <div class="growing-item-content">
            <v-chart v-if="!showRoeDetail" :options="growingBar" style="height:150px;" />
            <table v-else-if="roeratings.length > 0" class="dingpan-table">
              <tr>
                <th style="width:24%">机构名称</th>
                <th style="width:20%">研究员</th>
                <th style="width:28%;min-width:22vw;">2020预测</th>
                <th style="width:28%;min-width:22vw;">2021预测</th>
              </tr>
              <tr v-for="v in roeratings">
                <td>{{v.organization}}</td>
                <td>{{v.researcher}}</td>
                <td class="rating-value">
                  <span v-if="v.roe1 > 0" class="rating-icon red">↑</span>
                  <span v-else-if="v.roe1 < 0" class="rating-icon green">↓</span>
                  <span v-if="v.roe1 != 0">{{$utils.format("%.2f", v.roe1)}}</span>
                </td>
                <td class="rating-value">
                  <span v-if="v.roe2 > 0" class="rating-icon red">↑</span>
                  <span v-else-if="v.roe2 < 0" class="rating-icon green">↓</span>
                  <span v-if="v.roe2 != 0">{{$utils.format("%.2f", v.roe2)}}</span>
                </td>
              </tr>
            </table>
            <div v-else style="color:grey;margin-bottom:20px;">暂无预测数据</div>
          </div>
        </div>
        <!-- 净利润 -->
        <div class="growing-item" v-if="tab2Sel == 'profit'">
          <div class="growing-item-title">
            <div>
              净利润
              <span class="subtitle">(单位：百万元)</span>
            </div>
            <div class="growing-item-button" v-on:click="showProfitDetail=!showProfitDetail">
              <span></span>预测
            </div>
          </div>
          <div class="growing-item-content">
            <v-chart v-if="!showProfitDetail" :options="netProfitBar" style="height:150px;" />
            <table v-else-if="profitratings.length > 0" class="dingpan-table">
              <tr>
                <th style="width:24%">机构名称</th>
                <th style="width:20%">研究员</th>
                <th style="width:28%;min-width:22vw;">2020预测</th>
                <th style="width:28%;min-width:22vw;">2021预测</th>
              </tr>
              <tr v-for="v in profitratings">
                <td>{{v.organization}}</td>
                <td>{{v.researcher}}</td>
                <td class="rating-value">
                  <span v-if="v.netprofit1 > 0" class="rating-icon red">↑</span>
                  <span v-else-if="v.netprofit1 < 0" class="rating-icon green">↓</span>
                  {{v.netprofit1}}
                </td>
                <td class="rating-value">
                  <span v-if="v.netprofit2 > 0" class="rating-icon red">↑</span>
                  <span v-else-if="v.netprofit2 < 0" class="rating-icon green">↓</span>
                  {{v.netprofit2}}
                </td>
              </tr>
            </table>
            <div v-else style="color:grey;margin-bottom:20px;">暂无预测数据</div>
          </div>
        </div>
        <!-- 外资 -->
        <div class="growing-item" v-if="tab2Sel == 'foreign'">
          <div class="growing-item-title">
            <div>
              持仓/自由流动股份
              <span class="subtitle">(单位：%)</span>
            </div>
            <div class="help iconfont icon-help" @click="helpWaizi = true"></div>
            <!-- <div class="growing-item-button" v-on:click="showProfitDetail=!showProfitDetail">
              <span></span>预测
            </div> -->
          </div>
          <div class="growing-item-content">
            <div style="height:150px;margin-top:0px;margin-bottom:0px;">
              <v-chart :options="foreignLineOptions" />
            </div>
            <div style="color:#ccc;margin-left:10px;">
              <div>今日外资持仓占比：{{$utils.format("%.2f", info.nper)}}%，排名：{{info.nper?(info.inPer + ' /' + info.inAll) : '-'}}</div>
              <div>金牛基金持仓占比：{{$utils.format("%.2f", info.topFundPer)}}%</div>
            </div>
          </div>
        </div>
        <!-- 评级 -->
        <div class="growing-item" v-if="tab2Sel == 'rate'">
          <div class="growing-item-title">
            <div>
              机构评级：
              <span style="color:red;">{{info.ratingAvgChn}}</span>
            </div>
          </div>
          <div class="growing-item-content">
            <table class="dingpan-table">
              <tr>
                <th width="24%">机构名称</th>
                <th width="24%">研究员</th>
                <th width="24%">评级</th>
                <th width="28%">日期</th>
              </tr>
              <tr v-for="v in ratings">
                <td>{{v.organization}}</td>
                <td>{{v.researcher}}</td>
                <td>{{v.rating}}</td>
                <td>{{$utils.formatDate(v.date, 'yyyy.MM.dd')}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- 效率 -->
      <div class="split"></div>
      <div class="padding">
        <div class="top_title">效率</div>
        <div class="help iconfont icon-help" @click="helpXiaolv = true"></div>
        <div style="color:grey;font-size:13px;">股票上涨的节奏</div>
      </div>
      <div class="padding">
        <div style="height:200px;margin-top:20px;">
          <v-chart :options="priceLineOptions" />
        </div>
        <!-- <div style="height:200px;margin-top:20px;">
          <v-chart :options="efficiencyBarOptions" />
        </div> -->
        <div style="height:120px;margin-top:0px;margin-bottom:0px;">
          <v-chart :options="foreignBarOptions" />
        </div>
        <div style="color:#ccc;margin-left:10px;">
          <div>四周外资净流入：{{$utils.format("%.2f", info.ninflowing)}}亿，排名：{{info.ninflowing?info.inInflowing + ' /' + info.inAll : '-'}}</div>
          <div>今日外资净流入：{{$utils.format("%.3f", info.ninflowingToday)}}亿，排名：{{info.ninflowingToday?info.inInflowingToday : '-'}}</div>
        </div>
      </div>
      <div class="tabbar" style="margin-top: 0px;padding-top:10px;">
        <a
          v-for="tab in tabs1"
          :class="'tab ' + (tab1Sel==tab.code?'tab1Sel':'')"
          style="background-color:rgb(57, 80, 174);"
          v-on:click="tab1Sel=tab.code"
        >{{tab.name}}</a>
        <!-- <a class="tab" style="background-color:rgb(57, 80, 174);"><div class=" iconfont icon-help" @click="help1 = true"></div></a> -->
      </div>
      <div class="padding">
        <!-- 盯盘风格 -->
        <div class="growing-item" v-if="tab1Sel == 'style'">
          <div class="growing-item-title">
            <div>股票风格</div>
            <div class="help iconfont icon-help" @click="help1=true"></div>
          </div>
          <div class="growing-item-content">
            <!-- <div style="width:30%;float:left;color:grey;">{{$utils.formatDate(info.ftime, 'MM-dd hh:mm')}}</div> -->
            <table class="stat-table hangye-table" style="width:100%;float:right;">
              <tr>
                <th width="40"></th>
                <th width="50%">风格</th>
                <th>是否热点</th>
              </tr>
              <tr v-for="row in styles">
                <td>
                  <span v-if="info.style == row.indexCode">→</span>
                </td>
                <td>{{row.indexName}}</td>
                <td v-if="row.hot > 0" style="color:red;">√</td>
                <td v-else>×</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 盯盘强弱 -->
        <div class="growing-item" v-if="tab1Sel == 'qiangruo'">
          <div class="growing-item-title">
            <div>股票强弱</div>
            <div class="help iconfont icon-help" @click="help1=true"></div>
          </div>
          <div class="growing-item-content">
            <!-- <div style="width:30%;float:left;color:grey;">{{$utils.formatDate(info.ftime, 'MM-dd hh:mm')}}</div> -->
            <table class="stat-table hangye-table" style="width:100%;float:right;">
              <tr>
                <th width="40"></th>
                <th width="50%">强弱</th>
                <th>是否热点</th>
              </tr>
              <tr v-for="row in qiangruo">
                <td>
                  <span v-if="info.icp == row.indexCode">→</span>
                </td>
                <td>{{row.indexName}}</td>
                <td v-if="row.hot > 0" style="color:red;">√</td>
                <td v-else>×</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 盯盘行业 -->
        <div class="growing-item" v-if="tab1Sel == 'hangye'">
          <div class="growing-item-title">
            <div>股票行业</div>
            <div class="help iconfont icon-help" @click="help1=true"></div>
          </div>
          <div class="growing-item-content">
            <!-- <div style="width:30%;float:left;color:grey;">{{$utils.formatDate(info.ftime, 'MM-dd hh:mm')}}</div> -->
            <table class="stat-table hangye-table" style="width:100%;float:right;">
              <tr>
                <th width="40"></th>
                <th width="50%">行业</th>
                <th>是否热点</th>
              </tr>
              <tr v-for="row in hangye">
                <td>
                  <span v-if="info.indexCode == row.indexCode">→</span>
                </td>
                <td>{{row.indexName}}</td>
                <td v-if="row.hot > 0" style="color:red;">√</td>
                <td v-else>×</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 盯盘规模 -->
        <div class="growing-item" v-if="tab1Sel == 'guimo'">
          <div class="growing-item-title">
            <div>股票市值</div>
            <div class="help iconfont icon-help" @click="help1=true"></div>
          </div>
          <div class="growing-item-content">
            <!-- <div style="width:30%;float:left;color:grey;">{{$utils.formatDate(info.ftime, 'MM-dd hh:mm')}}</div> -->
            <table class="stat-table hangye-table" style="width:100%;float:right;">
              <tr>
                <th width="40"></th>
                <th width="50%">规模</th>
                <th>是否热点</th>
              </tr>
              <tr v-for="row in guimo">
                <td>
                  <span v-if="info.iasset == row.indexCode">→</span>
                </td>
                <td>{{row.indexName}}</td>
                <td v-if="row.hot > 0" style="color:red;">√</td>
                <td v-else>×</td>
              </tr>
            </table>
          </div>
        </div>
        <!-- 盯盘主题 -->
        <div class="growing-item" v-if="tab1Sel == 'topic'">
          <div class="growing-item-title">
            <div>股票主题</div>
            <div class="help iconfont icon-help" @click="help1=true"></div>
          </div>
          <div class="growing-item-content">
            <!-- <div style="width:30%;float:left;color:grey;">{{$utils.formatDate(info.ftime, 'MM-dd hh:mm')}}</div> -->
            <table class="stat-table hangye-table" style="width:100%;float:right;">
              <tr>
                <th width="40"></th>
                <th width="50%">主题</th>
                <th>是否热点</th>
              </tr>
              <tr v-for="row in topics">
                <td>
                  <span v-if="info.iasset == row.indexCode">-></span>
                </td>
                <td>{{row.indexName}}</td>
                <td v-if="row.hot > 0" style="color:red;">√</td>
                <td v-else>×</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <!-- 风险 -->
      <div class="split"></div>
      <div class="risk padding">
        <div class="risk_title">风险提示</div>
        <div v-if="info.risks.length > 0">
          <div class="risk-item" v-for="item in info.risks">
            <div class="tag">{{item.riskType}}</div>
            <div class="detail">{{item.riskName}}</div>
          </div>
        </div>
        <div v-else style="color:grey;margin-top:10px;font-size:12px;">暂无</div>
        <div style="height:5px;"></div>
      </div>
      <div class="page-bottom">
        <div>本结果由AlphaOX智能决策引擎提供技术支持</div>
        <!-- <div>
          AlphaOX已累计订阅
          <span class="visits" v-if="pv != null">{{pv}}</span>次
        </div> -->
      </div>
    </div>
    <van-dialog
      v-model="helpMzsm"
      title="免责声明"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1 本产品所提供信息并非投资决策服务，在任何情形下都不构成对接收本帐号内容受众的任何投资建议。用户应当充分了解各类投资风险，根据自身情况自主做出投资决策并自行承担风险。用户根据本产品做出的任何投资决策与本公司及相关内容提供方无关。</li>
          <li>2 本产品由南京解套宝数据技术有限公司基于牛棚模型、已公开的资料或信息开发，南京解套宝数据技术有限公司不对所载数据的准确性、可靠性、时效性和完整性做任何明示或暗示的保证。</li>
          <li>3 本产品是按照现有技术和条件所能达到的现状提供的服务，南京解套宝数据技术有限公司会尽最大努力向您提供服务，确保服务的连贯性和安全性。南京解套宝数据技术有限公司不保证本产品会无错误及不会中断、所有缺陷已被更正、或我们的产品或服务不会受到病毒或任何其他因素的损害。除非有法律明确规定，我们在此明确声明不承担任何明示或者暗示的担保责任。</li>
          <li>4 我们不能保证随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险，您不能要求我们承担责任。</li>
          <li>5 我们可独立决定随时立更、终止、中止您对我们服务的使用，无须向您发出任何提前通知，但根据法律法规规定或您与我们的约定需要提前通知的除外。若因您的行为违反法律法规的规定或本协议的规定，我们根据相关规定终止、中止您使用我们的服务，我们无须向您承担任何责任，且有权要求您承担相应的责任。</li>
          <li>6 我们的服务上使用第三方提供的信息，除遵守本协议约定外，您还应遵守第三方的用户协议。我们对第三方不承担任何责任。</li>
          <li>7 不同操作系统之间存在不互通的客观情况，该客观情况并非我们造成，由此可能导致您在某一操作系统中的充值不能顺利转移到另一操作系统中。由于您在不同系统进行切换造成的充值损失应由您自行承担，不得要求我们承担任何责任。</li>
          <li>8 我们可能因软件BUG、版本更新缺陷、第三方病毒攻击或其他任何因素等导致异常。在异常的原因未得到查明前，我们有权暂时冻结账号，且我们无须向您承担任何责任。</li>
          <li>9 本产品知识产权仅归南京解套宝数据技术有限公司所有，未经事先书面许可，任何人、任何机构不得以任何形式翻版、复制。</li>
          <li>10 南京解套宝数据技术有限公司对本声明具有唯一修改权和最终解释权。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpMzsm=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpDingyue"
      title="订阅"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1. 性价比＝价格/价值，与利润的稳健增长系数，一起构成基本面选股系统的二个基石因子。</li>
          <li>2. 技术买点，即通过Ｋ线形态分析，将股票分类关注、买点和路人三类。</li>
          <li>3. 今日关注是一个股票池，由逆市惊人表现、Ｂ浪创新高、风口和性价比等四个模型初选的股票池。</li>
          <li>4. AIT云盯盘系统实时监测市场，符合532三个买点之一的，即今天买点股票池。</li>
          <li>5. 订阅，请关注解套宝服务号，或联系客服小姐姐（微信号）。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpDingyue=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpHuayuquan"
      title="市场话语权"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1. 市场话语权，即国家队、蓝筹组、成长组和游资组四方力量之间的博弈与共存情况。</li>
          <li>2. 蓝筹掌门人巴菲特，成长掌门人彼得林奇，游资掌门人利弗莫尔，各有各的江湖。</li>
          <li>3. 表格中显示了四大门派的多空状况及主力资金流向。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpHuayuquan=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpQiangruo"
      title="相对大盘强弱"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1. 相对大盘强弱，将股票分为强势组、同步组和弱势组。</li>
          <li>2. 期间涨幅高于大盘的，归入强势组。期间涨幅低于大盘的，归入弱势组。期间涨幅同步大盘，上下偏离一直在20%之内的，归入同步组。</li>
          <li>3. 统计期间为2019年度。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpQiangruo=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpHangye"
      title="鹰眼.行业监测"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1. 监测wind一级行业的强弱、多空和主力资金流向，并按强度大小排序。</li>
          <li>2. 行业处于多方，红色显示；处于空方，绿色显示；多空不明显，灰色显示。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpHangye=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpTopic"
      title="鹰眼.主题监测"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1. 监测wind主题板块的强弱、多空和主力资金流向，并按强度大小排序。</li>
          <li>2. 行业处于多方，红色显示；处于空方，绿色显示；多空不明显，灰色显示。</li>
          <li>3. 本表格显示的是{{info?info.zqdm:''}}所属的全部主题。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpTopic=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="help1"
      title="五维分组及是否热点"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1. 风格维度：分为成长、价值及其它，私募游资在其它里。</li>
          <li>2. 强弱维度：近一年相对大盘的涨跌幅，分类强、同步、弱和其它，新股等在其它里。</li>
          <li>3. 行业维度：wind一级行业。</li>
          <li>4. 规模维度：按流动市值分为十亿级、百亿级和千亿以上三个组。</li>
          <li>5. 主题维度：wind主题，本股票所属所有主题。</li>
          <li>6. 股票助手显示本股票属于各个维度中的分组信息，以及是否热点。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="help1=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="help2"
      title="股票助手核心因子"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>1. 性价比：企业价值/股票价格，归一化为0－100， 100表示性价比最高，0表示性价比最低。</li>
          <li>2. 市值：可流动市值，单位亿元。</li>
          <li>3. 主力资金占比：近期主力净流入资金占比流动市值，正数流入，负数流出。</li>
          <li>4. 上图：股价相对指数走势，含四个关键点位：豹点、买点一、买点二和买点三。</li>
          <li>5. 下图：主力资金进、出情况，以及累计额，单位亿元。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="help2=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpXiaolv"
      title="效率"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>效率，是指股票上涨的节奏。</li>
          <li><br></li>
          <li>价值投资者，通常都看不起技术分析。</li>
          <li>但有些民间高手，确有自己的秘诀，能很好的把握股票的节奏，因而收益率特别可观。</li>
          <li><br></li>
          <li>出于知识产权，这里只展示二个效率模型： “买点”和”豹点”。</li>
          <li>另外，我们根据量价模型，在”风格、强弱、行业、规模和主题”评选出热点区域。如果股票在热点里，节奏可能更快些。</li>
          <li><br></li>
          <li>技术分析可以锦上添花，但离开基本面的技术分析，不可太较真。</li>
          <li>谋事在人，成事在天。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpXiaolv=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model="helpShenglv"
      title="胜率"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>胜率，是指股票上涨的概率。</li>
          <li><br></li>
          <li>如何预测一名中学生的高考成绩？</li>
          <li>根据常识，如果高一、高二的考试成绩名列前茅，则高考出彩的概率要大些。</li>
          <li>如果这位学生近几年的学习能力强，学习勤奋，老师的水平也高，则高考出彩的概率也会大些。</li>
          <li><br></li>
          <li>预测一支股票上涨的概率，道理差不多。</li>
          <li>我们用中长期、中期、短期的股价相对强弱指标RPS，来评估股票未来上涨的概率。三个时间框架分别是20天、120天，2019年1月1日以来。</li>
          <li><br></li>
          <li>胜率的本质，取决于股票质地。为之，我们精选了净利润、净资产收益率、外资持股和机构评级四个因子。</li>
          <li>十年的净利润稳健增长、净资产收益率稳健增长、外资重仓持有、机构评级高，则表示股票是一个好股票，未来上涨的概率会大些。</li>
          <li><br></li>
          <li>当然，平时的差生也可能考上清华北大，尖子生也可能意外落榜。</li>
          <li>99%的概率也会失败，1%的概率也会中彩。</li>
          <li>概率，是一种思维模式。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpShenglv=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model="helpPeilv"
      title="股票赔率"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>赔率是指股票可能的盈利空间。</li>
          <li>赔率越大，可能的盈利空间就越大。</li>
          <li><br></li>
          <li>赔率＝（未来股价/当前股价-1）*100</li>
          <li>未来股价＝一致预测bps*PB</li>
          <li><br></li>
          <li>一致预测bps来源于分析师研究报告，根据一致预测数据加权计算，分为1年、2年和5年。</li>
          <li>PB是市场给的，根据所在行业、主题和股票近七年的经营数据和行情数据，分为高估H、低估L和正常估值M。</li>
          <li>以上三个时间和三个估值，计算出九个赔率数据。</li>
          <li><br></li>
          <li>综合平均后，得出一个综合赔率数据，并归一化为0-100，评估该股票在所有A股中的相对位置。</li>
          <li>亏损股或一致预测亏损时，赔率为空。</li>
          <li><br></li>
          <li>左侧一个红色箭头，指向目前股价的相对估值位置。</li>
          <li>H之上虚线，为严重高估（也可能强者恒强）。</li>
          <li>L之下虚线，为极度低估（也可能有看不见的风险）。</li>
          <li>智者见智，仁者见仁。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpPeilv=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model="helpTotal"
      title="赔率·胜率·效率"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>选股就是在赔率、胜率、效率之间寻找平衡。</li>
          <li>赔率，股票上涨的空间。</li>
          <li>胜率，股票上涨的概率。</li>
          <li>效率，股票上涨的节奏。</li>
          <li><br></li>
          <li>赔率来源于企业的成长空间与目前的价格。</li>
          <li>胜率来源于企业增长的确定性。</li>
          <li>效率来源于资金的节奏。</li>
          <li><br></li>
          <li>不同投资理念优先项不同。</li>
          <li>价值投资胜率为先，短线操作效率为先。</li>
          <li>三者兼备者可遇不可求。</li>
          <li>若取其两项，我们建议优选高胜率和高赔率。</li>
          <li><br></li>
          <li>效率虽然可以做多种驱动情形推演，但是不可太较真，正所谓谋事在人，成事在天。</li>
          <li><br></li>
          <li>不同的人，资金属性不同，自我定位不同，追求目标不同，在理解内涵上没有绝对标准，但可以相互借鉴。</li>

        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpTotal=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="helpWaizi"
      title="外资&amp;金牛基金"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="help-content">
        <ul>
          <li>外资指北向资金。</li>
          <li>外资持仓占比，分母是自由流动股本，＝流通股本－其他扣除数。</li>
          <li>其他扣除数主要包括：1.持股>=5%的大股东持有的流通股份；2.持股<5%的股东持有的流通股份,考虑一致行动人(即和>=5%股东有关联关系或者虽然持股<5%,但关联方累计>=5%)；3.前10大股东或前10大流通股东中公布的高管持股数,一般全流通情况下扣除75%。</li>
          <li><br></li>
          <li>金牛基金持仓占比，分母同上。分子是指金牛Top30主动型公募基金的最近一个季度的十大重仓持股。</li>
          <li><br></li>
          <li>金牛Top30基金经理，囊括了A股目前在管理公募的最顶级基金经理，包括了一批成名已久的老将和这些年逐步冒头的中生代、新生代投资高手。</li>
          <li>根据至少三年以上的长期业绩、夏普指标、投资年限、投资风格、基金规模、换水波动等指标，全面考察各年度的收益率，并对1年、3年、5年、7年、10年段业绩赋予不同权重，经调整后的长期年化收益率排序。</li>
          <li>在此基础上，再结合深入调研，面对面访谈，考察基金经理获取超额收益的来源和能力圈所在，特别是剔除了有违规或违规隐患的基金，最终形成了Top30基金经理榜单。</li>
          <li><br></li>
          <li>北向资金，号称市场上最聪明的资金。</li>
          <li>金牛Top30基金，是目前最牛的一批顶级高手。</li>
          <li>他们看中的股票，股票质地基本是有保障的。</li>
        </ul>
        <div class="help-button">
          <van-button hairline plain size="small" type="default" @click="helpWaizi=false">知道了</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Dialog, Button, Toast } from "vant";
// import 'vant/lib/dialog/index.css';

import ECharts from "vue-echarts";

// 手动引入 ECharts 各模块来减小打包体积
import "echarts/lib/chart/pie";
import "echarts/lib/chart/gauge";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";

export default {
  name: "StockWatching",
  components: {
    "v-chart": ECharts,
    [Dialog.Component.name]: Dialog.Component,
    "van-button": Button,
    // [Button.Component.name]: Button.Component
  },
  data() {
    return {
      // stockApi: "https://m.00315.com",
      // stockApi: "http://v.00315.com",
      helpMzsm: false,
      helpDingyue: false,
      helpHuayuquan: false,
      helpQiangruo: false,
      helpHangye: false,
      helpTopic: false,
      help1: false,
      help2: false,
      helpXiaolv: false,
      helpShenglv: false,
      helpPeilv: false,
      helpTotal: false,
      helpWaizi: false,

      helpCode: "",
      tabSel: "account",
      pv: null,
      searching: false,
      keyword: null,
      info: null,
      matchList: null,
      rankOptions: null,
      shenglvLineOptions: null,
      priceLineOptions: null,
      rps1PieOptions: null,
      rps2PieOptions: null,
      rps3PieOptions: null,
      // mfdInFlowLineOptions: null,
      growingBar: null,
      netProfitBar: null,
      foreignLineOptions:null,
      foreignBarOptions:null,
      efficiencyBarOptions: null,
      styles: [],
      qiangruo: [],
      hangye: [],
      guimo: [],
      topics: [],
      tabs1: [
        {
          code: "style",
          name: "风格",
        },
        {
          code: "qiangruo",
          name: "强弱",
        },
        {
          code: "hangye",
          name: "行业",
        },
        {
          code: "guimo",
          name: "规模",
        },
        {
          code: "topic",
          name: "主题",
        },
      ],
      tab1Sel: "hangye",
      tabs2: [
        {
          code: "profit",
          name: "利润",
        },
        {
          code: "roe",
          name: "净资产收益率",
        },
        {
          code: "foreign",
          name: "外资",
        },
        {
          code: "rate",
          name: "评级",
        },
      ],
      tab2Sel: "roe",
      showProfitDetail: false,
      showRoeDetail: false,
      ratings: [],
      roeratings: [],
      profitratings: [],
      days: [],
    };
  },
  created() {
    document.title = "3+1选股助手";
  },
  mounted() {
    this.selectStock(this.$route.params.zqdm);
  },
  computed: {
    // barColor() {
    //   switch (this.info.barColor) {
    //     case 1:
    //       return "rgb(233,91,95)";
    //     case 2:
    //       return "rgb(0,86,163)";
    //     case 3:
    //       return "rgb(74,146,50)";
    //     default:
    //       return "#ccc";
    //   }
    // },
    colorClass() {
      return "red_active";
    },
    backgroundColor: function () {
      return "#f05a3c";
    },
    floatPos() {
      /*
      104时，指向L下方第4根虚线（最底处）
      103时，指向L下方第3根虚线
      102时，指向L下方第2根虚线
      101时，指向L下方第1根虚线（紧靠L）
      0-100时，对应实线相应位置（H对应0,   L对应100）
      -1时，指向H上方第1根虚线（紧靠H）
      -2时，指向H上方第2根虚线
      -3时，指向H上方第3根虚线
      -4时，指向H上方第4根虚线（最顶处）
      */
      //pbHigh: 18.43 pbLow: 1.54 pbM: 9.99 pbToday: 10.19
      var pb100 = this.info.pb100;
      window.console.log(pb100)
      var start= -9, base = 30, height = 63;
      if (pb100 == null) {
        return base + height/2;
      } else if (pb100 == -4) {
        return start + base/4;
      } else if (pb100 == -3) {
        return start + base/4*2;
      } else if (pb100 == -2) {
        return start + base/4*3;
      } else if (pb100 == -1) {
        return start + base;
      } else if (pb100 == 104) {
        return start + base + height + base + 6;
      } else if (pb100 == 103) {
        return start + base + height + base/4*3  + 6;
      } else if (pb100 == 102) {
        return start + base + height + base/4*2 + 6;
      } else if (pb100 == 101) {
        return start + base + height + base/4 + 6;
      } else {
        // return start + base + 6 + height/2;
        return start + base + 7 + height/100*pb100;
      }
    }
    // qrTitle() {
    //   switch (this.info.againstGroup) {
    //     case 1:
    //       return "强于大盘";
    //     case 2:
    //       return "同步大盘";
    //     case 3:
    //       return "弱于大盘";
    //     default:
    //       return "强弱";
    //   }
    // }
  },
  watch: {
    $route(to, from) {
      this.selectStock(to.params.zqdm);
    },
  },
  filters: {
    dataConvert(value) {
      return value ? value : "-";
    },
    percentConvert(value) {
      return value ? value + "%" : "-";
    },
  },
  methods: {
    peilvColor(v) {
      if (v > 0) return '#333';
      else if (v < 0) return 'green';
      else return 'black';
    },
    showMyStocks() {
      this.$router.push({ name: "MyStocks" });
    },
    choseStocks() {
      this.$router.push({ name: "ChooseStock" });
    },
    valueColor(value) {
      if (!value || value >= 0) {
        return "#868686";
      } else {
        return "green";
      }
    },
    addStock() {
      // this.$http
      //   .post("/pc/api/user/stocks", {
      //     zqdm: this.info.zqdm,
      //     zqjc: this.info.zqjc,
      //   })
      //   .then((res) => {
      //     this.info.hasAdded = true;
      //     this.$toast("已添加自选");
      //   });
    },
    removeStock() {
      // this.$http.delete("/pc/api/user/stocks/" + this.info.zqdm).then((res) => {
      //   this.info.hasAdded = false;
      //   this.$toast("已取消自选");
      // });
    },
    searchStocks() {
      this.matchList = null;
      if (this.keyword == "") {
        this.searching = false;
        return;
      } else {
        this.searching = true;
      }

      this.$http.get("/h5/api/web/stocks/?q=" + this.keyword).then((res) => {
        this.matchList = res.data;
      });
    },
    // 计算间隔，返回最大值，最小值 ，间隔
    getLeftData(min, max) {
      let splitNum = 4;
      let distance = 1;
      if (max - min < splitNum * 0.1) {
        max = Math.ceil(max * 20) / 20;
        min = Math.floor(min * 20) / 20;
        distance = Math.ceil(((max - min) * 20) / splitNum) / 20;
      } else if (max - min < splitNum * 0.2) {
        max = Math.ceil(max * 10) / 10;
        min = Math.floor(min * 10) / 10;
        distance = Math.ceil(((max - min) * 10) / splitNum) / 10;
      } else if (max - min < splitNum) {
        max = Math.ceil(max * 5) / 5;
        min = Math.floor(min * 5) / 5;
        distance = Math.ceil(((max - min) * 5) / splitNum) / 5;
      } else if (max - min < splitNum * 5) {
        max = Math.ceil(max);
        min = Math.floor(min);
        distance = Math.ceil((max - min) / splitNum);
      } else {
        max = Math.ceil(max);
        min = Math.floor(min);
        distance = Math.ceil((max - min) / (splitNum * 5)) * 5;
        if (distance >= 10) {
          min = Math.floor(min / 10) * 10;
          distance = Math.ceil((max - min) / (splitNum * 5)) * 5;
        } else {
          min = Math.floor(min / 5) * 5;
        }
        // min = Math.floor(min / 5) * 5;
        var fundZero = false;
      }
      max = min + distance * splitNum;
      return {
        max: max.toFixed(2),
        min: min,
        interval: distance,
      };
      // 控制分割条数，
      // const distance = parseInt(((max - min) / splitNum).toString(), 10);
      // return {
      //   max: splitNum * distance + min + splitNum,
      //   min,
      //   interval: distance + 1,
      // };
    },
    getTypeName(type) {
      if (type == 1) return "沪深300";
      else if (type == 2) return "中证500";
      else return "中证1000";
    },
    showStock(zqdm) {
      // this.$route.params.zqdm = zqdm;
      this.$router.push({ name: "StockWatching", params: { zqdm: zqdm } });
      // this.selectStock(zqdm);
    },
    selectStock(zqdm) {
      if (!zqdm || zqdm == "") zqdm = "default";
      this.keyword = "";
      this.searching = false;
      this.$http.get("/h5/api/web/stocks/" + zqdm).then((res) => {
        if (!res.data) return;
        this.info = res.data;
        if (this.info.indexName) {
          this.info.indexName = this.info.indexName.trim();
        }
        // this.$http.post("/h5/api/sys/visit/" + this.info.zqdm).then((res) => {
        //   if (res.data || res.data != "") {
        //     this.pv = res.data.pv;
        //   }
        // });
        this.rps1PieOptions = {
          title: {
              text: this.$utils.format("%.1f", this.info.rps1) + '%',
              left: 'center',
              top: 'middle',
              textStyle: {
                  color: '#000',
                  fontSize: 10
              }
          },
          legend: {
              orient: 'horizontal',
              bottom: 0,
              right: '30%',
              data: ['RPS20'],
              selectedMode: false,
              icon: 'none',
              textStyle: {
                  color: 'rgb(255, 155,0)',
                  fontSize: 10,
                  fontWeight: 'bold'
              }
          },
          series: [
              {
                  name: 'RPS20',
                  type: 'pie',
                  silent: true,
                  radius: ['45%', '55%'],
                  avoidLabelOverlap: false,
                  label: {
                      show: false,
                      position: 'center'
                  },
                  emphasis: {
                      label: {
                          show: true,
                          fontSize: '30',
                          fontWeight: 'bold'
                      }
                  },
                  labelLine: {
                      show: false
                  },
                  data: [
                      {value: this.info.rps1, name: 'RPS20',itemStyle: {
                          color: 'rgb(255, 155,0)'} },
                      {value: 100-this.info.rps1, name: 'Other',itemStyle: {
                          color: '#f9f9f9'}}
                  ]
              }
          ]
        };
        this.rps2PieOptions = {
          title: {
              text: this.$utils.format("%.1f", this.info.rps2) + '%',
              left: 'center',
              top: 'middle',
              textStyle: {
                  color: '#000',
                  fontSize: 10
              }
          },
          legend: {
              orient: 'horizontal',
              bottom: 0,
              right: '30%',
              data: ['RPS120'],
              selectedMode: false,
              icon: 'none',
              textStyle: {
                  color: 'rgb(25, 180, 110)',
                  fontSize: 10,
                  fontWeight: 'bold'
              }
          },
          series: [
              {
                  name: 'RPS120',
                  type: 'pie',
                  silent: true,
                  radius: ['45%', '55%'],
                  avoidLabelOverlap: false,
                  label: {
                      show: false,
                      position: 'center'
                  },
                  emphasis: {
                      label: {
                          show: true,
                          fontSize: '30',
                          fontWeight: 'bold'
                      }
                  },
                  labelLine: {
                      show: false
                  },
                  data: [
                      {value: this.info.rps2, name: 'RPS50',itemStyle: {
                          color: 'rgb(25, 180, 110)'} },
                      {value: 100-this.info.rps2, name: 'Other',itemStyle: {
                          color: '#f9f9f9'}}
                  ]
              }
          ]
        };
        this.rps3PieOptions = {
          title: {
              text: this.$utils.format("%.1f", this.info.rps3) + '%',
              left: 'center',
              top: 'middle',
              textStyle: {
                  color: '#000',
                  fontSize: 10
              }
          },
          legend: {
              orient: 'horizontal',
              bottom: 0,
              right: '30%',
              data: ['RPS2019'],
              selectedMode: false,
              icon: 'none',
              textStyle: {
                  color: 'rgb(60, 123, 246)',
                  fontSize: 10,
                  fontWeight: 'bold'
              }
          },
          series: [
              {
                  name: 'RPS2019',
                  type: 'pie',
                  silent: true,
                  radius: ['45%', '55%'],
                  avoidLabelOverlap: false,
                  label: {
                      show: false,
                      position: 'center'
                  },
                  emphasis: {
                      label: {
                          show: true,
                          fontSize: '30',
                          fontWeight: 'bold'
                      }
                  },
                  labelLine: {
                      show: false
                  },
                  data: [
                      {value: this.info.rps3, name: 'RPS50',itemStyle: {
                          color: 'rgb(60, 123, 246)'} },
                      {value: 100-this.info.rps3, name: 'Other',itemStyle: {
                          color: '#f9f9f9'}}
                  ]
              }
          ]
        };
        this.$http
          .get("/h5/api/web/stocks/" + this.info.zqdm + "/days")
          .then((res) => {
            if (res.data || res.data != "") {
              this.days = res.data;
              let dates = [],
                stockPrices = [],
                indexPrices = [],
                totalInflows = [],
                mfdInflowMs = [],
                avgValue = 0,
                maxValue = null,
                minValue = null,
                maxInFlow = null,
                minInFlow = null;
              this.days.forEach((item) => {
                dates.push(this.$utils.formatDate(item.date, "MM-dd"));
                stockPrices.push(item.stockP100);
                indexPrices.push(item.indexP100);
                totalInflows.push(item.totalInflow);
                mfdInflowMs.push(item.mfdInflowM);
                avgValue += item.stockP100;
                maxValue = maxValue
                  ? Math.max(maxValue, item.stockP100, item.indexP100)
                  : Math.max(item.stockP100, item.indexP100);
                minValue = minValue
                  ? Math.min(minValue, item.stockP100, item.indexP100)
                  : Math.min(item.stockP100, item.indexP100);
                maxInFlow = maxInFlow
                  ? Math.max(maxInFlow, item.totalInflow, item.mfdInflowM)
                  : Math.max(item.totalInflow, item.mfdInflowM);
                minInFlow = minInFlow
                  ? Math.min(minInFlow, item.totalInflow, item.mfdInflowM)
                  : Math.min(item.totalInflow, item.mfdInflowM);
              });
              if (stockPrices.length > 0) {
                avgValue = avgValue / stockPrices.length;
              }
              console.log(maxValue);
              console.log(minValue);
              let interval = this.getLeftData(minValue, maxValue);
              let intervalInFlow = this.getLeftData(minInFlow, maxInFlow);
              this.priceLineOptions = {
                backgroundColor: "#fff",
                grid: {
                  top: 10,
                  left: 30,
                  bottom: 58,
                },
                xAxis: {
                  type: "category",
                  position: "bottom",
                  boundaryGap: false,
                  // offset: 5,
                  data: dates,
                  axisLabel: {
                    // interval: 0,
                    rotate: 45,
                    color: "#ccc",
                    fontSize: 10,
                  },
                  axisLine: {
                    onZero: false,
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  splitLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  axisTick: {
                    // show: false,
                    alignWithLabel: true,
                    inside: true,
                    // interval: 0,
                    // length: 140,
                    lineStyle: {
                      color: "#b0b0b0",
                      // type: "dotted"
                    },
                  },
                },
                yAxis: {
                  type: "value",
                  // min: interval.min,
                  // max: interval.max,
                  // interval: interval.interval,
                  scale: true,
                  axisLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  splitNumber: 5,
                  minInterval: 1,
                  axisLabel: {
                    // showMinLabel: false,
                    // showMaxLabel: true,
                    color: (value, index) => {
                      return value == 0 ? "grey" : value > 0 ? "red" : "green";
                    },
                  },
                  splitLine: {
                    show: false,
                    lineStyle: {
                      color: "#f00",
                    },
                  },
                },
                // color:['rgb(150, 200, 255)','rgb(235, 205, 130)'],
                color: ["rgb(150, 200, 255)", "#b4b4b4"],
                legend: {
                  icon: "rect",
                  textStyle: {
                    color: "#ccc",
                    fontSize: 11,
                  },
                  itemHeight: 1,
                  bottom: 0,
                  // data: [this.info.zqjc, '沪深300']
                },
                series: [
                  {
                    name: this.info.zqjc,
                    data: stockPrices.map((value, index, array) => {
                      return {
                        value: value,
                        symbol:
                          (this.days[index].buying == 0 && this.days[index].following <= 0) ? "none" : "triangle",
                        symbolSize: 10,
                        itemStyle: {
                          color:
                          this.days[index].following > 0 ? "purple":
                            (this.days[index].buying > 0
                              ? "rgb(255, 0, 0)"
                              : "rgb(0, 176, 80)"),
                        },
                      };
                    }),
                    type: "line",
                    animation: false,
                    showAllSymbol: true,
                    symbol: "none",
                    lineStyle: {
                      // color: "rgb(150, 200, 255)",
                      width: 2,
                    },
                  },
                  {
                    name: this.getTypeName(this.info.type),
                    data: indexPrices,
                    type: "line",
                    animation: false,
                    symbol: "none",
                    lineStyle: {
                      // color: "rgb(235, 205, 130)",
                      width: 2,
                    },
                  },
                ],
              };
              this.shenglvLineOptions = {
                backgroundColor: "#fff",
                grid: {
                  top: 10,
                  left: 50,
                  bottom: 58,
                },
                xAxis: {
                  type: "category",
                  position: "bottom",
                  boundaryGap: false,
                  // offset: 5,
                  data: dates,
                  axisLabel: {
                    // interval: 0,
                    rotate: 45,
                    color: "#ccc",
                    fontSize: 10,
                  },
                  axisLine: {
                    onZero: false,
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  splitLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  axisTick: {
                    // show: false,
                    alignWithLabel: true,
                    inside: true,
                    // interval: 0,
                    // length: 140,
                    lineStyle: {
                      color: "#b0b0b0",
                      // type: "dotted"
                    },
                  },
                },
                yAxis: {
                  type: "value",
                  max: 100,
                  min: 0,
                  interval: 20,
                  // min: interval.min,
                  // max: interval.max,
                  // interval: interval.interval,
                  scale: true,
                  axisLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  // splitNumber: 6,
                  // minInterval: 20,
                  axisLabel: {
                    formatter: '{value}%'
                  //   // showMinLabel: false,
                  //   // showMaxLabel: true,
                  //   color: (value, index) => {
                  //     return value == 0 ? "grey" : value > 0 ? "red" : "green";
                  //   },
                  },
                  splitLine: {
                    show: false,
                    lineStyle: {
                      color: "#f00",
                    },
                  },
                },
                // color:['rgb(150, 200, 255)','rgb(235, 205, 130)'],
                color: ["rgb(255, 155,0)", "rgb(60, 123, 246)"],
                legend: {
                  icon: "rect",
                  textStyle: {
                    color: "#ccc",
                    fontSize: 11,
                  },
                  itemHeight: 1,
                  bottom: 0,
                  // data: [this.info.zqjc, '沪深300']
                },
                series: [
                  {
                    name: 'RPS20',
                    data: this.days.map((value, index, array) => {
                      return {
                        value: value.rps1
                      };
                    }),
                    type: "line",
                    animation: false,
                    showAllSymbol: true,
                    symbol: "none",
                    lineStyle: {
                      // color: "rgb(150, 200, 255)",
                      width: 2,
                    },
                  },
                  {
                    name: 'RPS2019',
                    data: this.days.map((value, index, array) => {
                      return {
                        value: value.rps3
                      };
                    }),
                    type: "line",
                    animation: false,
                    symbol: "none",
                    lineStyle: {
                      // color: "rgb(235, 205, 130)",
                      width: 2,
                    },
                  },
                ],
              };
              // this.mfdInFlowLineOptions = {
              //   backgroundColor: "#fff",
              //   grid: {
              //     top: 6,
              //     left: 50,
              //     bottom: 30,
              //   },
              //   xAxis: {
              //     type: "category",
              //     // boundaryGap: false,
              //     // offset: 5,
              //     data: dates,
              //     axisLabel: {
              //       show: false,
              //       // interval: 0,
              //       rotate: 45,
              //       color: "#999",
              //       fontSize: 10,
              //     },
              //     axisLine: {
              //       show: false,
              //       lineStyle: {
              //         color: "#f00",
              //       },
              //     },
              //     splitLine: {
              //       show: false,
              //       lineStyle: {
              //         color: "#f00",
              //       },
              //     },
              //     axisTick: {
              //       show: false,
              //     },
              //   },
              //   yAxis: {
              //     type: "value",
              //     // min: intervalInFlow.min,
              //     // max: intervalInFlow.max,
              //     // interval: intervalInFlow.interval,
              //     scale: false,
              //     axisLabel: {
              //       show: true,
              //       // interval: 0,
              //       // showMaxLabel: true,
              //       // showMinLabel: true
              //     },
              //     axisLine: {
              //       show: true,
              //       lineStyle: {
              //         color: "#b0b0b0",
              //       },
              //     },
              //     axisTick: {
              //       show: true,
              //       interval: 0,
              //     },
              //     splitLine: {
              //       show: false,
              //       lineStyle: {
              //         color: "#ccc",
              //         type: "dotted",
              //       },
              //     },
              //   },
              //   color: ["rgb(192, 0 , 0)", "rgb(0, 176, 80)"],
              //   legend: {
              //     icon: "rect",
              //     textStyle: {
              //       color: "#ccc",
              //       fontSize: 11,
              //     },
              //     formatter: "{name} (亿元)",
              //     selectedMode: false,
              //     itemHeight: 8,
              //     itemWidth: 2,
              //     bottom: 0,
              //     data: ["主力净流入", "主力净流出"],
              //   },
              //   series: [
              //     {
              //       name: "主力净流入",
              //       data: totalInflows,
              //       type: "line",
              //       animation: false,
              //       symbol: "none",
              //       lineStyle: {
              //         color: "#b4b4b4",
              //         width: 1,
              //       },
              //     },
              //     {
              //       name: "主力净流出",
              //       data: mfdInflowMs.map((value, index, array) => {
              //         return {
              //           value: value,
              //           //自定义标签样式，仅对该数据项有效
              //           // label: {
              //           //   show: value.dataType == 1 && !value.roe ? true : false,
              //           //   color: "#999",
              //           //   formatter: "暂无",
              //           //   position: ["0%", -15]
              //           // },
              //           //自定义特殊 itemStyle，仅对该数据项有效
              //           itemStyle: {
              //             color:
              //               value > 0 ? "rgb(192, 0 , 0)" : "rgb(0, 176, 80)",
              //           },
              //         };
              //       }),
              //       type: "bar",
              //       animation: false,
              //     },
              //   ],
              // };
              this.foreignLineOptions = {
                backgroundColor: "#fff",
                grid: {
                  top: 10,
                  bottom: 40
                  // left: 50,
                  // bottom: 58,
                },
                xAxis: {
                  type: "category",
                  position: "bottom",
                  boundaryGap: false,
                  // offset: 5,
                  data: dates,
                  axisLabel: {
                    // interval: 0,
                    rotate: 45,
                    color: "#ccc",
                    fontSize: 10,
                  },
                  axisLine: {
                    onZero: false,
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  splitLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  axisTick: {
                    // show: false,
                    alignWithLabel: true,
                    inside: true,
                    // interval: 0,
                    // length: 140,
                    lineStyle: {
                      color: "#b0b0b0",
                      // type: "dotted"
                    },
                  },
                },
                yAxis: {
                  type: "value",
                  // min: interval.min,
                  // max: interval.max,
                  // interval: interval.interval,
                  scale: true,
                  axisLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  // splitNumber: 5,
                  // minInterval: 1,
                  // axisLabel: {
                  //   // showMinLabel: false,
                  //   // showMaxLabel: true,
                  //   color:  (value, index) => {
                  //       return value == 0? 'grey': (value > 0 ? 'red' : 'green');
                  //   }
                  // },
                  splitLine: {
                    show: false,
                    lineStyle: {
                      color: "#f00",
                    },
                  },
                },
                // color:['rgb(150, 200, 255)','rgb(235, 205, 130)'],
                color: ["rgb(150, 200, 255)", "#b4b4b4"],
                legend: {
                  show: false,
                  icon: "rect",
                  textStyle: {
                    color: "#ccc",
                    fontSize: 11,
                  },
                  itemHeight: 1,
                  bottom: 0,
                  // data: [this.info.zqjc, '沪深300']
                },
                series: [
                  {
                    name: this.info.zqjc,
                    data: this.days.map((value, index, array) => {
                      return {
                        value: value.nper,
                        // symbol: this.days[index].buying == 0 ?'none':'triangle',
                        // symbolSize: 10,
                        // itemStyle : {
                        //   color: this.days[index].buying>0?"rgb(255, 0, 0)":"rgb(0, 176, 80)"
                        // }
                      };
                    }),
                    type: "line",
                    animation: false,
                    showAllSymbol: true,
                    symbol: "none",
                    lineStyle: {
                      // color: "rgb(150, 200, 255)",
                      width: 2,
                    },
                  },
                ],
              };
              this.foreignBarOptions = {
                // grid: {
                //   x: 0,
                //   y: 10,
                //   x2: 5,
                //   y2: 30,
                // },
                grid: {
                  top: 10,
                  bottom: 40
                  // left: 50,
                  // bottom: 58,
                },
                xAxis: {
                  type: "category",
                  position: "bottom",
                  boundaryGap: false,
                  // offset: 5,
                  data: dates,
                  axisLabel: {
                    // interval: 0,
                    rotate: 45,
                    color: "#ccc",
                    fontSize: 10,
                  },
                  axisLine: {
                    onZero: false,
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  splitLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  axisTick: {
                    // show: false,
                    alignWithLabel: true,
                    inside: true,
                    // interval: 0,
                    // length: 140,
                    lineStyle: {
                      color: "#b0b0b0",
                      // type: "dotted"
                    },
                  },
                },
                yAxis: {
                  type: "value",
                  axisLabel: {
                    color: "#999",
                    fontSize: 10,
                  },
                  splitLine: {
                    lineStyle: {
                      type: "dotted",
                    },
                  },
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                },
                series: [
                  {
                    // barMaxWidth: 20,
                    data: this.days.map((value, index, array) => {
                      return {
                        value: value.ninflowing || 0,
                        itemStyle: {
                          color:
                          value.ninflowing > 0 ? "red":"green",
                        }
                      };
                    }),
                    type: "bar",
                    animation: false,
                  },
                ],
              };
              this.efficiencyBarOptions = {
                grid: {
                  top: 10,
                  left: 50
                  // bottom: 58,
                },
                xAxis: {
                  type: "category",
                  position: "bottom",
                  boundaryGap: false,
                  // offset: 5,
                  data: dates,
                  axisLabel: {
                    // interval: 0,
                    rotate: 45,
                    color: "#ccc",
                    fontSize: 10,
                  },
                  axisLine: {
                    onZero: false,
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  splitLine: {
                    lineStyle: {
                      color: "#b0b0b0",
                    },
                  },
                  axisTick: {
                    // show: false,
                    alignWithLabel: true,
                    inside: true,
                    // interval: 0,
                    // length: 140,
                    lineStyle: {
                      color: "#b0b0b0",
                      // type: "dotted"
                    },
                  },
                },
                legend: {
                  show: true,
                  icon: "rect",
                  textStyle: {
                    color: "#ccc",
                    fontSize: 11,
                  },
                  itemHeight: 1,
                  bottom: 0,
                  // data: [this.info.zqjc, '沪深300']
                },
                yAxis: {
                  type: "value",
                  axisLabel: {
                    color: "#999",
                    fontSize: 10,
                  },
                  splitLine: {
                    lineStyle: {
                      type: "dotted",
                    },
                  },
                  axisLine: {
                    show: false,
                  },
                  axisTick: {
                    show: false,
                  },
                },
                series: [
                  {
                    name: '动量+势能',
                    // barMaxWidth: 20,
                    data: this.days.map((value, index, array) => {
                      return {
                        value: value.ds || 0,
                      };
                    }),
                    type: "bar",
                    animation: false,
                  },
                ],
              };
            }
          });

        this.$http.get("/h5/api/web/basic/styles").then((res) => {
          if (res.data || res.data != "") {
            this.styles = res.data;
          }
        });
        this.$http.get("/h5/api/web/basic/qiangruo").then((res) => {
          if (res.data || res.data != "") {
            this.qiangruo = res.data;
          }
        });
        this.$http.get("/h5/api/web/basic/hangye").then((res) => {
          if (res.data || res.data != "") {
            this.hangye = res.data;
          }
        });
        this.$http.get("/h5/api/web/basic/asset").then((res) => {
          if (res.data || res.data != "") {
            this.guimo = res.data;
          }
        });

        this.$http
          .get("/h5/api/web/stocks/" + this.info.zqdm + "/topics")
          .then((res) => {
            if (res.data || res.data != "") {
              this.topics = res.data;
            }
          });
        this.$http
          .get("/h5/api/web/stocks/" + this.info.zqdm + "/profitratings")
          .then((res) => {
            if (res.data || res.data != "") {
              this.profitratings = res.data;
            }
          });

        this.$http
          .get("/h5/api/web/stocks/" + this.info.zqdm + "/roeratings")
          .then((res) => {
            if (res.data || res.data != "") {
              this.roeratings = res.data;
            }
          });

        this.$http
          .get("/h5/api/web/stocks/" + this.info.zqdm + "/ratings")
          .then((res) => {
            if (res.data || res.data != "") {
              this.ratings = res.data;
            }
          });

        this.rankOptions = {
          series: [
            {
              name: "业务指标",
              type: "gauge",
              radius: "90%",
              axisLine: {
                // 坐标轴线
                lineStyle: {
                  // 属性lineStyle控制线条样式
                  width: 5,
                  color: [
                    [0.2, "rgb(0, 176, 80)"],
                    [0.79999, "#999"],
                    [1, "rgb(192, 0 , 0)"],
                  ],
                },
              },
              axisTick: {
                // 坐标轴小标记
                length: 8, // 属性length控制线长
                lineStyle: {
                  // 属性lineStyle控制线条样式
                  color: "auto",
                },
              },
              splitLine: {
                // 分隔线
                length: 10, // 属性length控制线长
                lineStyle: {
                  // 属性lineStyle（详见lineStyle）控制线条样式
                  color: "auto",
                },
              },
              axisLabel: {
                // backgroundColor: 'auto',
                // borderRadius: 2,
                // color: '#eee',
                // padding: [-25, -25],
                distance: -32,
                formatter: function (value) {
                  if (value != 0 && value != 100) return "";
                  else return " " + value;
                },
                // textShadowBlur: 2,
                // textShadowOffsetX: 1,
                // textShadowOffsetY: 1,
                // textShadowColor: '#222'
              },
              pointer: {
                width: 3,
                length: "70%",
              },
              detail: {
                fontSize: 11,
                formatter: "赔率",
                color: "#000",
                fontWeight: "bold",
                fontFamily: "黑体",
                offsetCenter: [0, "65%"],
              },
              data: [{ value: this.info.iv, name: this.info.iv }],
            },
          ],
        };
        this.growingBar = this.info.growings
          ? {
              grid: {
                x: 60,
                y: 10,
                x2: 5,
                y2: 30,
              },
              xAxis: {
                axisLabel: {
                  interval: 0,
                  rotate: 45,
                  color: "#999",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                type: "category",
                data: this.info.growings.map((value, index, array) => {
                  return value.year;
                }),
              },
              yAxis: {
                type: "value",
                axisLabel: {
                  color: "#999",
                  fontSize: 10,
                  formatter: "{value}%",
                },
                splitLine: {
                  lineStyle: {
                    type: "dotted",
                  },
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
              series: [
                {
                  data: this.info.growings.map((value, index, array) => {
                    return {
                      value: value.roe || 0,
                      //自定义标签样式，仅对该数据项有效
                      label: {
                        show: value.dataType == 1 && !value.roe ? true : false,
                        color: "#999",
                        formatter: "暂无",
                        position: ["0%", -15],
                      },
                      //自定义特殊 itemStyle，仅对该数据项有效
                      itemStyle: {
                        color:
                          value.dataType == 0
                            ? "rgb(131,177,229)"
                            : "rgb(255, 215,0 )",
                      },
                    };
                  }),
                  type: "bar",
                  barMaxWidth: 20,
                  animation: false,
                },
              ],
            }
          : null;
        this.netProfitBar = this.info.growings
          ? {
              grid: {
                x: 60,
                y: 10,
                x2: 5,
                y2: 30,
              },
              xAxis: {
                axisLabel: {
                  interval: 0,
                  rotate: 45,
                  color: "#999",
                  fontSize: 10,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
                type: "category",
                data: this.info.growings.map((value, index, array) => {
                  return value.year;
                }),
              },
              yAxis: {
                type: "value",
                axisLabel: {
                  color: "#999",
                  fontSize: 10,
                },
                splitLine: {
                  lineStyle: {
                    type: "dotted",
                  },
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
              series: [
                {
                  barMaxWidth: 20,
                  data: this.info.growings.map((value, index, array) => {
                    return {
                      value: value.netProfit || 0,
                      //自定义标签样式，仅对该数据项有效
                      label: {
                        show:
                          value.dataType == 1 && !value.netProfit
                            ? true
                            : false,
                        color: "#999",
                        formatter: "暂无",
                        position: ["0%", -15],
                      },
                      //自定义特殊 itemStyle，仅对该数据项有效
                      itemStyle: {
                        color:
                          value.dataType == 0
                            ? "rgb(131,177,229)"
                            : "rgb(255, 215,0 )",
                      },
                    };
                  }),
                  type: "bar",
                  animation: false,
                },
              ],
            }
          : null;
      });
    },
  },
};
</script>
<style scoped>
.td-border-right {
  border-right: 1px solid #999;
}

.td-border-bottom {
  border-bottom: 1px solid #999;
}

.peilv table {
  border-collapse: collapse;
  border-spacing: 0px;
  font-size: 12px;
  width: 100%;
}

.peilv td {
  padding-right: 2px;
  text-align: center;
}

.help {
  float: right;
  height: 20px;
  color: #999 !important;
  line-height: 20px;
}
.echarts {
  width: 100%;
  height: 100%;
}
.padding {
  padding: 10px 20px 10px 20px;
}
.header {
  height: 54px;
  position: relative;
  background-color: #ccc;
}

.header > div:first-child {
    margin-left: 10px;
    margin-right:10px;
    padding-top: 10px;
}

/* .header > div:last-child {
    position: absolute;
    width: 50px;
    right: 0px;
    top: 0px;
    height: 100%;
    line-height: 54px;
} */

.search::-webkit-input-placeholder {
  font-size: 13px;
}

.search-box {
  position: relative;
}

.search-box input {
  border-radius: 20px;
  background-color: #fff;
  height: 34px;
  border: 0px;
  padding: 10px;
  width: 100%;
}
.match-list {
  position: absolute;
  top: 54px;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 99;
}

.match-list li {
  border-bottom: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}

.headimg {
  width: 34px;
  border-radius: 17px;
  vertical-align: middle;
}
.brief {
  position: relative;
  background: #efefef;
  /* margin-top: 10px; */
}
.info {
}

.info .name {
  font-size: 20px;
  margin: 0px;
  color: #83b1e5;
  display: inline-block;
}

.add-stock-button {
  font-size: 10px;
  display: inline-block;
  color: #f00;
  border: solid 1px #f00;
  border-radius: 2px;
  line-height: 18px;
  height: 20px;
  padding: 0px 5px;
  margin-left: 10px;
  vertical-align: top;
  margin-top: 5px;
}

.info .zqdm {
  font-size: 13px;
  color: #868686;
}

.info .paihangbang {
  margin-top: 10px;
  font-size: 13px;
  line-height: 15px;
}

.info .paihangbang > div > span:first-child {
  display: inline-block;
  width: 30px;
  text-align: right;
  margin-right: 5px;
}

.peilv {
  position: relative;
  /* height: 120px; */
}

.peilv .rank {
  /* position: absolute; */
  /* top: 15px; */
  /* right: 0px; */
  display: inline-block;
  width: 40%;
  height: 120px;
}

.tips {
  margin-top: 0px;
  padding: 0 10px 10px 20px;
}

.tips > span:first-child {
  font-size: 9px;
  color: #cfcfcf;
}

.tips > span:last-child {
  font-size: 12px;
  color: #9085c8;
}

.split {
  height: 10px;
  background-color: #f6f6f6;
}

.kline {
  overflow: auto;
}

.title {
  display: inline-block;
  font-size: 14px;
  height: 20px;
  line-height: 20px;
  border-bottom: solid #ffb5b5 10px;
  color: #ce0000;
}

.kline .title {
  border-bottom-color: #ffb5b5;
  color: #ce0000;
}
.kline .bar-outline {
  display: inline-block;
  float: left;
  border: 1px solid #ccc;
  width: 15px;
  margin-left: 10px;
}
.kline .bar {
  height: 100px;
}

.kline .bar-left {
  display: inline-block;
  float: left;
  position: relative;
  height: 100px;
  margin-top: 0px;
}

.kline .bar-left div {
  height: 33%;
  line-height: 33px;
}

.kline .bar-text {
  position: absolute;
  left: 90px;
  top: 0px;
}

.kline .bar-text > div:first-child {
  color: red;
}

.kline .buying {
  float: right;
  margin-right: 20px;
}

.kline .buying .buying-block {
  position: relative;
  height: 20px;
  width: 70px;
  line-height: 20px;
  padding-left: 20px;
  background-size: cover;
  background-color: #ccc;
  color: #000;
}

.kline .buying .buying-block:first-child {
  margin-top: 4px;
}

.kline .buying .buying-block:not(:first-of-type) {
  margin-top: 8px;
}

.kline .buying .buying-block > span {
  position: absolute;
  right: -20px;
  color: red;
  font-weight: bold;
  font-size: 16px;
}

.kline .buying .maidian {
  background-image: url(/pc/img/stocks/orange.jpg);
  color: white;
}
.kline .buying .guanzhu {
  background-image: url(/pc/img/stocks/blue.jpg);
  color: white;
}
.kline .buying .luren {
  background-image: url(/pc/img/stocks/green.jpg);
  color: white;
}

.kline .buying-tips {
  /* float: right; */
  font-size: 12px;
  margin-top: 6px;
}

.growing {
}

.growing-item {
  margin-top: 10px;
}

.growing-item-title {
  overflow: auto;
  height: 22px;
}

.growing-item-title > div:first-child {
  float: left;
  line-height: 22px;
  background: url(/pc/img/stocks/arrow.png) no-repeat;
  background-size: contain;
  padding-left: 25px;
}

.growing-item-title .subtitle {
  font-size: 12px;
  color: #cfcfcf;
  margin-left: 5px;
}

.growing-item-button {
  float: right;
  color: #666666;
  border: solid 1px #83b1e5;
  border-radius: 2px;
  line-height: 18px;
  padding: 0px 5px;
  background: url(/pc/img/stocks/click.png) no-repeat;
  background-position: 5px 2px;
  background-size: 28%;
  padding-left: 25px;
  font-size: 12px;
}

.growing-item-content {
  /* height: 150px; */
  overflow: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.risk .title {
  border-bottom-color: #ceffce;
  color: #009100;
}

.risk-item {
  display: flex;
  margin: 10px 0px;
}

.risk-item .tag {
  background-color: #00a600;
  border-radius: 4px;
  color: white;
  padding: 3px 5px;
  font-size: 10px;
}

.risk-item .detail {
  margin-left: 10px;
  padding: 2px 0px;
  font-size: 12px;
  color: #676767;
}

.page-bottom {
  color: #cfcfcf;
  text-align: center;
  font-size: 11px;
  margin: 10px 0px 20px 0px;
  line-height: 14px;
}

.page-bottom .visits {
  color: #5291f5;
  margin: 0px 5px;
}
.tabbar {
  background-color: #fff;
  border-bottom: 1px solid #f2f2f2;
}

.tab {
  color: #fff;
}
.tab.red_active {
  /*color: #f05a3c;
    border-bottom:2px solid #f05a3c;*/
  /*color: #fff;
	background-color: #f05a3c;*/
  color: rgb(195, 215, 153);
}

.tab.yellow_active {
  /*color: #fc9f26;
    border-bottom:2px solid #fc9f26;*/
  /*color: #fff;
	background-color: #fc9f26;*/
  color: rgb(195, 215, 153);
}

.tab.blue_active {
  /*color: #4486ed;
    border-bottom:2px solid #4486ed;*/
  /*color: #fff;
	background-color: #4486ed;*/
  color: rgb(195, 215, 153);
}
/*页签菜单栏*/
.tabbar {
  display: table;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  min-height: 40px;
}

.tab {
  display: table-cell;
  width: 1%;
  padding-top: 8px;
  padding-bottom: 8px;
  /*height:42px;
    line-height: 42px; */
  overflow: hidden;
  line-height: 1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
  font-size: 16px;
}

.tab:active,
.tab.active {
  -webkit-box-sizing: border-box;
}
.tab1Sel {
  color: yellow;
  font-weight: bold;
}
.tab2Sel {
  color: yellow;
  font-weight: bold;
}
.stat-table {
  /* border-top: 1px solid #ccc; */
  /* border-left: 1px solid #ccc; */
  border-collapse: collapse;
  text-align: center;
}
.stat-table th:not(:first-child) {
  border-top: 1px solid #ccc;
  background-color: #eee;
  font-weight: bold;
}
/* .stat-table th:nth-child(1) {
    width: 20%;
}
.stat-table th:nth-child(2) {
    width: 40%;
}

.stat-table th:nth-child(3) {
    width: 15%;
}

.stat-table th:nth-child(4) {
    width: 25%;
} */

.duokong {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
}

.mfd {
  text-align: right !important;
  padding-right: 5px;
}

.stat-table td,
.stat-table th {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.stat-table td {
  line-height: 22px;
}
.stat-table th {
  line-height: 24px;
}

.stat-table tr > td:first-child {
  text-align: right;
  color: red;
  font-weight: bold;
  padding-right: 10px;
}

.red {
  color: red;
}

.green {
  color: green;
}

.grey {
  color: grey;
}

.stat-table tr > th:first-child,
.stat-table tr > td:first-child {
  border-bottom: none;
}

.stat-table tr.tail td {
  border: none;
  font-size: 13px;
}

.stat-table tr.tail td:not(:first-child) {
  color: grey;
  text-align: left;
  padding-top: 5px;
}

.qiangruo {
  position: relative;
  width: 25%;
  float: left;
}

.qiangruo .bar-outline {
  display: inline-block;
  float: left;
  border: 1px solid #ccc;
  width: 15px;
  margin-left: 10px;
}

.qiangruo .bar-text {
  position: absolute;
  left: 30px;
  top: 0px;
  font-size: 12px;
  font-weight: bold;
}

.qiangruo .bar-text > div:nth-child(2) {
  color: red;
}

.hangye-qiangruo,
.hangye-topic {
  text-align: center;
}

.maidian-table {
  width: 40%;
  float: right;
  border-collapse: collapse;
}

.maidian-table tr:not(:last-child) td:first-child {
  border-left: 1px solid #ccc;
  color: grey;
}

.maidian-table tr:first-child td {
  border-top: 1px solid #ccc;
  color: grey;
}

.maidian-table tr:not(:last-child) td {
  text-align: center;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  color: grey;
}

.maidian-table tr:not(:last-child) td {
  text-align: center;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.maidian-table tr:last-child td {
  padding-top: 5px;
  text-decoration: underline;
  color: rgb(57, 80, 174);
}

.hangye-table tr > td:nth-child(2) {
  text-align: left;
  padding-left: 5px;
}

.growing-item-title div:not(:first-child) {
  float: right;
  color: #999;
}

.dingpan-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

.dingpan-table th {
  background-color: #eee;
  line-height: 28px;
}

.dingpan-table th,
.dingpan-table td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.dingpan-table td {
  line-height: 24px;
}

.rating-value {
  text-align: right;
  padding-right: 10px;
  position: relative;
}

.rating-icon {
  position: absolute;
  left: 8px;
}
.help-content {
  overflow: auto;
  max-height: 75vh;
  padding: 10px;
  font-size: 13px;
}

.help-button {
  margin: 15px 10px 10px 10px;
  text-align: center;
}

.help-button button {
  padding: 0 20px;
}

.maidian-mark {
  width: 55%;
  float: left;
  border-collapse: collapse;
  margin-top: 5px;
}
.maidian-mark tr:first-child td {
  text-align: center;
  border-right: 1px solid #ccc;
  background-color: #eee;
}
.maidian-mark tr:first-child td:last-child {
  border-right: none;
}

.top_title {
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 2px;
}
.top_title span {
  color:#999;
  font-size: 16px;
  line-height: 24px;
  vertical-align: top;
  font-weight: normal;
}
.risk_title {
  font-size: 20px;
  font-weight: bold;
  color: #00a600;
  line-height: 24px;
}

.risk_title span {
  color:#999;
  font-size: 16px;
  line-height: 24px;
  vertical-align: top;
  font-weight: normal;
}
</style>


